import React from 'react';
import {Navigate} from 'react-router';
import {useSelector} from 'react-redux';

function RouteForAdmin({children}) {
  const {userInfo} = useSelector (state => state.auth);
  const {role} = userInfo;
  return role?.categories?.includes('admin') ? children : <Navigate to="/" />;
}

export default RouteForAdmin;
